import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { capitalizeWordsRemoveDash } from "../../utils/text.utils";

export default function PromotionBreadcrumbs({ promotionType, query }) {

    const isSearchWithQuery = promotionType === "search" && query;

    return (
        <nav className="breadcrumb-wrapper">
            <Link to="/" className="breadcrumb-item" title="Home">
                Home
            </Link>

            {isSearchWithQuery ? (
                <span className="breadcrumb-segment">
                    <span className="breadcrumb-separator">
                        <ChevronRight size={20} />
                    </span>

                    <span className="breadcrumb-item active">
                        {query}
                    </span>
                </span>
            ) : (
                /* Normal promotion */
                promotionType && (
                    <span className="breadcrumb-segment">
                        <span className="breadcrumb-separator">
                            <ChevronRight size={20} />
                        </span>

                        <span className="breadcrumb-item active">
                            {capitalizeWordsRemoveDash(promotionType)}
                        </span>
                    </span>
                )
            )}
        </nav>
    );
}